import { api } from './client';

export const eventsApi = {
  list: () => api.get('/events').then((r) => r.data),
  get: (id) => api.get(`/events/${id}`).then((r) => r.data),
  create: (data) => api.post('/events', data).then((r) => r.data),
  update: (id, data) => api.patch(`/events/${id}`, data).then((r) => r.data),
  publish: (id) => api.post(`/events/${id}/publish`).then((r) => r.data),
  remove: (id) => api.delete(`/events/${id}`).then((r) => r.data),
  getPublic: (shortCode) => api.get(`/public/i/${shortCode}`).then((r) => r.data),
};